import { useFeatureFlagEnabled } from 'posthog-js/react';

import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { useHasPermissionToAccessPage } from '@/hooks/useHasPermissionToAccessPage';
import { isTest } from '@/legacy/utils/env';

/**
 * Gate for the new /employees portfolio page. Both gates must be true:
 * the EmployeePortfolioOverview page is in /api/me permittedPages, and
 * the has_employee_portfolio PostHog rollout flag is on.
 */
export const useHasEmployeePortfolio = () => {
  const { hasPermission: hasEmployeePortfolioPagePermission } =
    useHasPermissionToAccessPage('EmployeePortfolioOverview');

  const rollOutEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.EMPLOYEE_PORTFOLIO,
  );

  if (isTest) {
    return false;
  }

  return Boolean(rollOutEnabled) && hasEmployeePortfolioPagePermission;
};
